import { useCallback } from 'react';

import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { useModal } from 'react-modal-hook';
import { useHistory } from 'react-router-dom';

import clockImage from 'assets/images/clock.png';

const toggleRootBlur = (enabled: boolean) => {
  const rootDiv = document.getElementById('root');

  if (!rootDiv) {
    return;
  }

  rootDiv.classList.toggle('blur-sm', enabled);
};

export const useSessionExpiredModal = () => {
  const history = useHistory();

  const navigateToLogin = () => {
    const { pathname, search } = window.location;

    history.push({ pathname: '/login', search: `?backUrl=${encodeURIComponent(pathname + search)}` });
  };

  const [showModal, hideModal] = useModal(({ in: open }) => {
    return (
      <Dialog maxWidth="xs" open={open}>
        <DialogContent className="px-5 pb-12 pt-9 text-center">
          <img alt="clock-image" height={80} src={clockImage} width={80} />
          <Typography className="mb-2 mt-6 text-center" variant="h1">
            Session expired
          </Typography>
          <Typography className="text-center" variant="body1">
            Your session has timed out. Log in again.
          </Typography>
        </DialogContent>

        <DialogActions className="px-4 pb-5 pt-0">
          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              hideModal();
              toggleRootBlur(false);
              navigateToLogin();
            }}
          >
            Log in
          </Button>
        </DialogActions>
      </Dialog>
    );
  });

  const handleSessionExpired = useCallback(() => {
    toggleRootBlur(true);

    showModal();
  }, [showModal]);

  return { handleSessionExpired };
};
